import _reactJsxRuntimeProduction from "./cjs/react-jsx-runtime.production.js";
export { _reactJsxRuntimeProduction as default };
export const Fragment = _reactJsxRuntimeProduction.Fragment,
  jsx = _reactJsxRuntimeProduction.jsx,
  jsxs = _reactJsxRuntimeProduction.jsxs;